import * as React from 'react';

import { Dialog, DialogProps } from '~shared/components/Dialog';

export interface Props
  extends Omit<DialogProps, 'children' | 'padding' | 'position'> {
  children: React.ReactNode;
  position?: 'right' | 'left';
}

export function Drawer({ children, position = 'right', ...props }: Props) {
  return (
    <Dialog {...props} position={position} padding="none">
      {children}
    </Dialog>
  );
}
